import { html } from 'lit';
import { MapPin } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-map-pin')
export class PdsIconMapPin extends PdsIcon {
  @state()
  icon = MapPin;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
